export enum WorkManagerPayrollStatusEnum {
    Created,
    Finished,
    Canceled,
}
